import React, { useState } from 'react';
import { Web3Provider } from './contexts/Web3Context';
import Swap from './components/Swap';
import Liquidity from './components/Liquidity';
import Analytics from './components/Analytics';
import About from './components/About';
import WalletConnect from './components/WalletConnect';
import { useBlockchainData } from './hooks/useBlockchainData';
import { useWeb3 } from './contexts/Web3Context';
import './future4000.css';

const App4000: React.FC = () => {
  const { provider } = useWeb3();
  const { totalLiquidity, totalPairs, volume24h, puzoUsdtPool } = useBlockchainData(provider);
  const [activeTab, setActiveTab] = useState('swap');

  return (
    <div className="app-4000">
      {/* Quantum Background Elements */}
      <div className="quantum-grid"></div>
      <div className="energy-field"></div>
      
      <div className="nexus-container">
        {/* Header */}
        <div className="nexus-header">
          <h1 className="nexus-title">PUZODEX</h1>
          <div className="nexus-subtitle">CRYPTOGRAPHIC COMPUTATION PROTOCOL</div>
        </div>

        {/* Wallet Connection */}
        <div className="wallet-nexus">
          <WalletConnect />
        </div>

        {/* Statistics */}
        <div className="quantum-stats">
          <div className="quantum-stat">
            <div className="stat-label">Total Liquidity</div>
            <div className="stat-value">${totalLiquidity}</div>
          </div>
          <div className="quantum-stat">
            <div className="stat-label">Active Pairs</div>
            <div className="stat-value">{totalPairs}</div>
          </div>
          <div className="quantum-stat">
            <div className="stat-label">24h Volume</div>
            <div className="stat-value">${volume24h}</div>
          </div>
          {puzoUsdtPool && (
            <div className="quantum-stat">
              <div className="stat-label">PUZO Price</div>
              <div className="stat-value">
                ${(parseFloat(puzoUsdtPool.reserve1) / parseFloat(puzoUsdtPool.reserve0)).toFixed(6)}
              </div>
            </div>
          )}
        </div>

        {/* Navigation */}
        <div className="neural-nav">
          <button 
            className={`neural-tab ${activeTab === 'swap' ? 'active' : ''}`}
            onClick={() => setActiveTab('swap')}
          >
            Swap
          </button>
          <button 
            className={`neural-tab ${activeTab === 'liquidity' ? 'active' : ''}`}
            onClick={() => setActiveTab('liquidity')}
          >
            Liquidity
          </button>
          <button 
            className={`neural-tab ${activeTab === 'analytics' ? 'active' : ''}`}
            onClick={() => setActiveTab('analytics')}
          >
            Analytics
          </button>
          <button 
            className={`neural-tab ${activeTab === 'about' ? 'active' : ''}`}
            onClick={() => setActiveTab('about')}
          >
            Protocol
          </button>
        </div>

        {/* Content */}
        {activeTab === 'swap' && <Swap />}
        {activeTab === 'liquidity' && <Liquidity />}
        {activeTab === 'analytics' && <Analytics />}
        {activeTab === 'about' && <About />}

        {/* Social Links */}
        <div className="nexus-links">
          <a href="https://t.me/Puzo_btc" target="_blank" rel="noopener noreferrer" className="nexus-link">
            Telegram
          </a>
          <a href="https://github.com/puzbit" target="_blank" rel="noopener noreferrer" className="nexus-link">
            GitHub
          </a>
        </div>
      </div>
    </div>
  );
};

const App: React.FC = () => {
  return (
    <Web3Provider>
      <App4000 />
    </Web3Provider>
  );
};

export default App;
